import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-show-requirement-information',
  templateUrl: './show-requirement-information.component.html',
  styleUrls: ['./show-requirement-information.component.scss']
})
export class ShowRequirementInformationComponent implements OnInit {
  @Input() data: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  detailData: any;
  isLoading = false;
  dataForm: FormGroup;
  displayedColumns: string[] = ['statusChanged', 'comment', 'statusDate'];
  dataSource: any;
  allRegister: any;
  public pageSize: number = 5;

  constructor(
    private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private paginatorIntl: MatPaginatorIntl,
    private utilService: UtilService,
  ) {
    this.paginatorIntl.itemsPerPageLabel = this.utilService.paginatorIntl.itemsPerPageLabel;
    this.paginatorIntl.getRangeLabel = this.utilService.paginatorIntl.getRangeLabel;
  }

  ngOnInit(): void {
    this.detailData = this.data;
    this.createForm();
  }

  private createForm(): any {
    this.dataForm = this.fb.group({
      id: [this.data.id],
      code: [this.data.code],
      rrType: [this.data.rRType],
      detail: [this.data.detail],
      currentStatus: [this.data.currentStatus],
      dateRegister: [this.data.dateRegister],

      theme: [this.data.theme],
      sure: [this.data.sure],
      date: [this.data.date],
      request: [this.data.request],

      document: [this.data.document],
      contactName: [this.data.contactName],
      lastNames: [this.data.lastName + ' ' + this.data.secondLastName],
      email: [this.data.email],
      cellPhone: [this.data.codCountry + this.data.cellPhone],
      district: [this.data.district],
      contactWays: [this.data.contactWays],
      licensePlate: [this.data.licensePlate],
    });

    this.allRegister = this.data.detailList.length;
    this.dataSource = new MatTableDataSource(this.data.detailList.slice(5 * 0, this.pageSize * (0 + 1)));
  }

  onPageFired(event): any {
    this.dataSource = new MatTableDataSource(this.data.detailList.slice(5 * event.pageIndex, this.pageSize * (event.pageIndex + 1)));
  }

  onNoClick(): void {
    this.activeModal.close();
  }
}
